<template>
  <div>
    <!-- Page Content -->
    <div class="content">
      <!-- Full Table -->
      <base-block rounded title="Test List">
        <div class="text-right">
          <b-button variant="success" href="/#/backend/forms/edit-tests"
            >+ Add Test</b-button
          >
        </div>
        <br />
        <div class="d-flex justify-content-end mb-2">
          <input
            class="form-control"
            type="text"
            placeholder="Search..."
            aria-label="Search"
            style="width: 300px"
          />
        </div>
        <b-table-simple responsive bordered striped table-class="table-vcenter">
          <b-thead>
            <b-tr>
              <b-th class="text-center">S.NO</b-th>
              <b-th class="text-center">Test Type</b-th>
              <b-th class="text-center">Test Name</b-th>
              <b-th class="text-center">Description</b-th>
              <b-th class="text-center">Duration(mins)</b-th>
              <b-th class="text-center">No.Of Questions</b-th>
              <b-th class="text-center">Attempts</b-th>
              <b-th class="text-center">Negative Marks</b-th>
              <b-th class="text-center">Each Question Mark</b-th>
              <b-th class="text-center">Start Date</b-th>
              <b-th class="text-center">Start Time</b-th>
              <b-th class="text-center">End Date</b-th>
              <b-th class="text-center">End Time</b-th>
              <b-th class="text-center">Result Status</b-th>
              <b-th class="text-center">Status</b-th>
              <b-th class="text-center">Action</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr v-for="question in questions" :key="question.id">
              <b-td class="text-center">
                {{ question.id }}
              </b-td>
              <b-td class="text-center">
                {{ question.testType }}
              </b-td>
               <b-td class="text-center">
                {{ question.name }}
              </b-td>
              <b-td class="text-center">{{ question.description }}</b-td>
                <b-td class="text-center">{{ question.duration }}</b-td>
              <b-td class="text-center">{{ question.noOfQuestions }}</b-td>
              <b-td class="text-center">
                {{question.attempts}}
              </b-td>
              <b-td class="text-center">
                {{ question.negativeMark }}
              </b-td>
              <b-td class="text-center">
                {{ question.eachQuestionMark }}
              </b-td>
              <b-td class="text-center">
                {{ question.startDate }}
              </b-td>
              <b-td class="text-center">
                {{ question.startTime }}
              </b-td>
              <b-td class="text-center">
                {{ question.endDate }}
              </b-td>
              <b-td class="text-center">
                {{ question.endTime }}
              </b-td>
              <b-td class="text-center">
                {{ question.result }}
              </b-td>
              <b-td class="text-center">
                <b-badge :variant="question.labelVariant">{{
                  question.labelText
                }}</b-badge>
              </b-td>
              <b-td class="text-center">
                <b-btn-group>
                  <b-button
                    size="sm"
                    variant="alt-primary"
                    href="/#/backend/forms/edit-tests"
                  >
                    <i class="fa fa-fw fa-pencil-alt"></i>
                  </b-button>
                  <b-button size="sm" variant="alt-primary" href="">
                    <i class="fa fa-fw fa-times"></i>
                  </b-button>
                </b-btn-group>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </base-block>
      <!-- END Full Table -->
    </div>
    <!-- END Page Content -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      questions: [
        {
          id: 1,
          testType: "Daily Test",
          name: "Numbers Test 1",
          description: "This is a daily test",
          duration: 60,
          noOfQuestions: 25,
          attempts: 5,
          negativeMark: 0.25,
          eachQuestionMark: 2,
          startDate: "21/12/1995",
          startTime: "5:45 PM",
          endDate: "21/12/1995",
          endTime: "5:45 PM",
          endDateTime: "1611812967772",
          result: "-",
          labelVariant: "danger",
          labelText: "Deactive",
        },

        {
          id: 2,
          testType: "Mock Test",
           name: "Numbers Test 2",
          description: "This is a mock test",
          duration: 45,
          noOfQuestions: 45,
          attempts: 1,
          negativeMark: "-",
          eachQuestionMark: 2,
          startDate: "21/12/1995",
          startTime: "5:45 PM",
          endDate: "21/12/1995",
          endTime: "5:45 PM",
          result: "result",
          labelVariant: "success",
          labelText: "Active",
        },
      ],
    };
  },
};
</script>
 